import React from "react";
import ReactQuill from "react-quill";
import formFileUploadIcon from "../../Assets/formFileUploadIcon.svg";
import { useDispatch } from "react-redux";
import { updateItemQuestion } from "../../Redux/Reducer/FormSlices";

const AVFileUploadQuestion = ({
  id,
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <>
      <div className="singleQuestion-Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div class="fileUpload_container">
        <img src={formFileUploadIcon} alt="formFileUploadIcon" />
        <div className="fileUpload_text_container">
          <p className="text">Select a file or drag and drop here</p>
          <p className="sndtext">
            JPG, PNG or PDF, file size no more than 10MB
          </p>
        </div>
        <div className="file_select">Select File</div>
      </div>
    </>
  );
};

export default AVFileUploadQuestion;
